import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';

const DropdownIndicator = React.memo((props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Icon name="arrowDropDown" />
            </components.DropdownIndicator>
        )
    );
});

DropdownIndicator.displayName = 'DropdownIndicator';

export default DropdownIndicator;
